export default class VerifyCode {
  constructor(container, options) {
    this.container = container;
    this.options = {
      inputSelector: '.js-verify-code-input',
      maskContainerSelector: '.js-verify-code-mask',
      maskClass: 'pfx-verify-code__mask-value',
      activeClass: 'is-active',
      ...options,
    };
    this.maskElements = [];
  }

  init() {
    const input = this.container.querySelector(this.options.inputSelector);
    const maskContainerSelector = this.container.querySelector(this.options.maskContainerSelector);
    this.generateMaskElements(input, maskContainerSelector);
    this.addEvents(input);
  }

  addEvents(input) {
    input.addEventListener('input', () => {
      const digitsArray = Array.from(input.value).map(Number);

      this.setMaskElements(digitsArray);
    });
  }

  setMaskElements(digitsArray) {
    this.maskElements.forEach((element, index) => {
      const el = element;
      el.innerText = digitsArray[index] !== undefined ? digitsArray[index] : '-';

      if (digitsArray[index] !== undefined) {
        el.classList.add('is-active');
      } else {
        el.classList.remove('is-active');
      }
    });
  }

  generateMaskElements(input, container) {
    this.maskElements = [];
    if (input && input.getAttribute('maxlength')) {
      const length = input.getAttribute('maxlength');
      const list = Array.from({ length }, (_, i) => i + 1);

      list.forEach(() => {
        const maskEl = document.createElement('span');
        maskEl.classList.add(this.options.maskClass);
        maskEl.innerText = '-';
        this.maskElements.push(maskEl);
        container.appendChild(maskEl);
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const verifyCodes = Array.from(document.querySelectorAll('.js-verify-code'));
  verifyCodes.forEach((container) => {
    const verifyCode = new VerifyCode(container);
    verifyCode.init();
  });
});
